<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    ...mapActions("auth", ["magicSignin"]),
  },

  async mounted() {
    if (!this.token) {
      console.error("No token provided for magic signin");
      this.$router.push("/signin");
      return;
    }

    const response = await this.magicSignin({ token: this.token });

    if (response?.success) {
      // Redirect to home page on successful signin
      this.$router.push("/");
    } else {
      console.error("Magic signin failed:", response);
      this.$router.push("/signin");
    }
  },
};
</script>
